import React from 'react'
import * as classes from './iconlink.module.scss'

export default function Iconlink(props) {
    return (
        <a className={classes.Iconlink} href={props.url} target={props.target ? props.target : "_blank"} rel="noreferrer">
            <i className={"icon-" + props.icon}></i>
        </a>
    )
}